import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  academyTopicSelector,
  setPrimaryInstructor,
} from 'features/classCreation';
import ScheduleInstructorSelect from '../ScheduleInstructorSelect';

function PrimaryInstructorSelect({ cls }) {
  const dispatch = useDispatch();
  const academyTopic = useSelector((state) =>
    academyTopicSelector(state, cls.academy_topic.id)
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(
        setPrimaryInstructor({
          academyTopicId: cls.academy_topic.id,
          instructor: value,
        })
      );
    },
    [cls.academy_topic.id, dispatch]
  );

  if (academyTopic?.isInstructorRequired) {
    return (
      <ScheduleInstructorSelect
        academyTopic={academyTopic}
        onChange={handleChange}
        placeholder="Primary Instructor"
        value={academyTopic?.primaryInstructor}
      />
    );
  } else {
    return <div className="hint p-h-xxs">N/A</div>;
  }
}

export default PrimaryInstructorSelect;
